import React, { FC, useCallback, useMemo } from 'react';
import UploadWithSampleModal from '../flatfile/UploadWithSampleModal';
import {
	getReceivedEquipmentFlatfileHeader,
	PARTIAL_UPLOAD_CRUD_FIELD,
	getFlatfileRecordForReceivedEquipmentExport,
} from '../stock_locations_detail_details_page/stock_location_constants';
import { CSV_EXPORT_DEFAULTS } from '../../utils/DataConstants';
import { ExportToCsv } from 'export-to-csv';
import { requiredWithValueRecordHook } from '../flatfile/faltfile_utils';

const PartialEPSLUpload: FC<any> = ({
	hideUploadPopup,
	allEquipmentTypesNames,
	allVendorNames,
	onDataUpload,
	recordHook,
}): React.ReactElement => {
	const FLATFILE_HEADER_WITH_CRUD_ACTION = useMemo(
		() => [
			PARTIAL_UPLOAD_CRUD_FIELD,
			...getReceivedEquipmentFlatfileHeader(allEquipmentTypesNames, allVendorNames),
		],
		[allEquipmentTypesNames, allVendorNames]
	);

	const onDownloadSample = useCallback(() => {
		const csvTitle = `Partial_Equipment_Upload_Sample`;
		const csvExporter = new ExportToCsv({
			...CSV_EXPORT_DEFAULTS,
			filename: csvTitle,
			title: csvTitle,
			headers: FLATFILE_HEADER_WITH_CRUD_ACTION.map((_) => _.label),
		});

		const data = [
			{
				crudAction: 'create',
				...getFlatfileRecordForReceivedEquipmentExport({}),
			},
			{
				crudAction: 'update',
				...getFlatfileRecordForReceivedEquipmentExport({ id: 1234 }),
			},
			{
				crudAction: 'delete',
				...getFlatfileRecordForReceivedEquipmentExport({ id: 4567 }),
			},
		];
		csvExporter.generateCsv(data);
	}, [FLATFILE_HEADER_WITH_CRUD_ACTION]);

	const updatedRecordHook = (record) => {
		const updatedRecord = recordHook ? recordHook(record) : record;
		return requiredWithValueRecordHook(['id'], 'crudAction', ['update', 'delete'])(updatedRecord);
	};

	return (
		<UploadWithSampleModal
			type="Partial Equipment Upload"
			title="Partial Equipment Upload"
			downloadText="Do you want to download Sample?"
			sampleFileText="Download Sample"
			recordHook={updatedRecordHook}
			onCancel={hideUploadPopup}
			onDownloadSample={onDownloadSample}
			fields={FLATFILE_HEADER_WITH_CRUD_ACTION}
			onDataLoad={onDataUpload}
		/>
	);
};

export default PartialEPSLUpload;
